/**
 * DB Contact Form Block - Consent Validation
 * Handles consent checkbox validation and form submission
 */

(function() {
  'use strict';

  function initContactForm(form) {
    const submitButton = form.querySelector('.db-contact-form__submit');
    const consentRequired = submitButton?.dataset.consentRequired === 'true';
    const consentId = submitButton?.dataset.consentId;
    
    if (!consentRequired || !consentId) {
      return; // No consent validation needed
    }

    const consentCheckbox = form.querySelector(`#${consentId}`);
    const consentHint = form.querySelector(`#${consentId}-hint`);
    
    if (!consentCheckbox || !consentHint) {
      return;
    }

    // Update button state based on checkbox
    function updateButtonState() {
      if (consentCheckbox.checked) {
        submitButton.disabled = false;
        consentHint.style.display = 'none';
      } else {
        submitButton.disabled = true;
      }
    }

    // Show validation hint on interaction
    let hasInteracted = false;
    
    function handleInteraction() {
      if (!hasInteracted) {
        hasInteracted = true;
        if (!consentCheckbox.checked) {
          consentHint.style.display = 'block';
        }
      }
    }

    // Handle form submission
    function handleSubmit(e) {
      if (!consentCheckbox.checked) {
        e.preventDefault();
        consentCheckbox.focus();
        consentHint.style.display = 'block';
        hasInteracted = true;
        return false;
      }
    }

    // Initialize
    updateButtonState();
    
    // Event listeners
    consentCheckbox.addEventListener('change', function() {
      updateButtonState();
      handleInteraction();
    });

    consentCheckbox.addEventListener('click', handleInteraction);
    consentCheckbox.addEventListener('focus', handleInteraction);
    
    form.addEventListener('submit', handleSubmit);
  }

  // Initialize all contact forms on page load
  function initAllForms() {
    const forms = document.querySelectorAll('.db-contact-form__form');
    forms.forEach(initContactForm);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllForms);
  } else {
    initAllForms();
  }

  // Re-initialize on Shopify Theme Editor events
  if (typeof window.Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', function(event) {
      const forms = event.detail.querySelectorAll('.db-contact-form__form');
      forms.forEach(initContactForm);
    });

    document.addEventListener('shopify:block:select', function(event) {
      const form = event.detail.querySelector('.db-contact-form__form');
      if (form) {
        initContactForm(form);
      }
    });
  }
})();
